export default __webpack_public_path__ + "static/media/hamburger_icon.9a1a709f.svg";